/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AppAbsenceRouteImport } from './routes/_app.absence'

const AppIndexLazyRouteImport = createFileRoute('/_app/')()
const AuthPasswordResetLazyRouteImport = createFileRoute(
  '/auth/password-reset',
)()
const AuthLogoutLazyRouteImport = createFileRoute('/auth/logout')()
const AuthLoginLazyRouteImport = createFileRoute('/auth/login')()
const Auth2faEnableLazyRouteImport = createFileRoute('/auth/2fa-enable')()
const AppTeamLazyRouteImport = createFileRoute('/_app/team')()
const AppSettingsLazyRouteImport = createFileRoute('/_app/settings')()
const AppProfileLazyRouteImport = createFileRoute('/_app/profile')()
const AppDashboardLazyRouteImport = createFileRoute('/_app/dashboard')()
const AppClientsLazyRouteImport = createFileRoute('/_app/clients')()
const AppUsersIndexLazyRouteImport = createFileRoute('/_app/users/')()
const AppUsersAddLazyRouteImport = createFileRoute('/_app/users/add')()
const AppUsersCompareUserIdLazyRouteImport = createFileRoute(
  '/_app/users/compare/$userId',
)()
const AppUsersUserIdEditLazyRouteImport = createFileRoute(
  '/_app/users/$userId/edit',
)()

const AuthRoute = AuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexLazyRoute = AppIndexLazyRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any).lazy(() => import('./routes/_app.index.lazy').then((d) => d.Route))
const AuthPasswordResetLazyRoute = AuthPasswordResetLazyRouteImport.update({
  id: '/password-reset',
  path: '/password-reset',
  getParentRoute: () => AuthRoute,
} as any).lazy(() =>
  import('./routes/auth.password-reset.lazy').then((d) => d.Route),
)
const AuthLogoutLazyRoute = AuthLogoutLazyRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => AuthRoute,
} as any).lazy(() => import('./routes/auth.logout.lazy').then((d) => d.Route))
const AuthLoginLazyRoute = AuthLoginLazyRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any).lazy(() => import('./routes/auth.login.lazy').then((d) => d.Route))
const Auth2faEnableLazyRoute = Auth2faEnableLazyRouteImport.update({
  id: '/2fa-enable',
  path: '/2fa-enable',
  getParentRoute: () => AuthRoute,
} as any).lazy(() =>
  import('./routes/auth.2fa-enable.lazy').then((d) => d.Route),
)
const AppTeamLazyRoute = AppTeamLazyRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => AppRoute,
} as any).lazy(() => import('./routes/_app.team.lazy').then((d) => d.Route))
const AppSettingsLazyRoute = AppSettingsLazyRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any).lazy(() => import('./routes/_app.settings.lazy').then((d) => d.Route))
const AppProfileLazyRoute = AppProfileLazyRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AppRoute,
} as any).lazy(() => import('./routes/_app.profile.lazy').then((d) => d.Route))
const AppDashboardLazyRoute = AppDashboardLazyRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app.dashboard.lazy').then((d) => d.Route),
)
const AppClientsLazyRoute = AppClientsLazyRouteImport.update({
  id: '/clients',
  path: '/clients',
  getParentRoute: () => AppRoute,
} as any).lazy(() => import('./routes/_app.clients.lazy').then((d) => d.Route))
const AppAbsenceRoute = AppAbsenceRouteImport.update({
  id: '/absence',
  path: '/absence',
  getParentRoute: () => AppRoute,
} as any)
const AppUsersIndexLazyRoute = AppUsersIndexLazyRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app.users.index.lazy').then((d) => d.Route),
)
const AppUsersAddLazyRoute = AppUsersAddLazyRouteImport.update({
  id: '/users/add',
  path: '/users/add',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app.users.add.lazy').then((d) => d.Route),
)
const AppUsersCompareUserIdLazyRoute =
  AppUsersCompareUserIdLazyRouteImport.update({
    id: '/users/compare/$userId',
    path: '/users/compare/$userId',
    getParentRoute: () => AppRoute,
  } as any).lazy(() =>
    import('./routes/_app.users.compare.$userId.lazy').then((d) => d.Route),
  )
const AppUsersUserIdEditLazyRoute = AppUsersUserIdEditLazyRouteImport.update({
  id: '/users/$userId/edit',
  path: '/users/$userId/edit',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app.users.$userId.edit.lazy').then((d) => d.Route),
)

export interface FileRoutesByFullPath {
  '/auth': typeof AuthRouteWithChildren
  '/absence': typeof AppAbsenceRoute
  '/clients': typeof AppClientsLazyRoute
  '/dashboard': typeof AppDashboardLazyRoute
  '/profile': typeof AppProfileLazyRoute
  '/settings': typeof AppSettingsLazyRoute
  '/team': typeof AppTeamLazyRoute
  '/auth/2fa-enable': typeof Auth2faEnableLazyRoute
  '/auth/login': typeof AuthLoginLazyRoute
  '/auth/logout': typeof AuthLogoutLazyRoute
  '/auth/password-reset': typeof AuthPasswordResetLazyRoute
  '/': typeof AppIndexLazyRoute
  '/users/add': typeof AppUsersAddLazyRoute
  '/users': typeof AppUsersIndexLazyRoute
  '/users/$userId/edit': typeof AppUsersUserIdEditLazyRoute
  '/users/compare/$userId': typeof AppUsersCompareUserIdLazyRoute
}
export interface FileRoutesByTo {
  '/auth': typeof AuthRouteWithChildren
  '/absence': typeof AppAbsenceRoute
  '/clients': typeof AppClientsLazyRoute
  '/dashboard': typeof AppDashboardLazyRoute
  '/profile': typeof AppProfileLazyRoute
  '/settings': typeof AppSettingsLazyRoute
  '/team': typeof AppTeamLazyRoute
  '/auth/2fa-enable': typeof Auth2faEnableLazyRoute
  '/auth/login': typeof AuthLoginLazyRoute
  '/auth/logout': typeof AuthLogoutLazyRoute
  '/auth/password-reset': typeof AuthPasswordResetLazyRoute
  '/': typeof AppIndexLazyRoute
  '/users/add': typeof AppUsersAddLazyRoute
  '/users': typeof AppUsersIndexLazyRoute
  '/users/$userId/edit': typeof AppUsersUserIdEditLazyRoute
  '/users/compare/$userId': typeof AppUsersCompareUserIdLazyRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/auth': typeof AuthRouteWithChildren
  '/_app/absence': typeof AppAbsenceRoute
  '/_app/clients': typeof AppClientsLazyRoute
  '/_app/dashboard': typeof AppDashboardLazyRoute
  '/_app/profile': typeof AppProfileLazyRoute
  '/_app/settings': typeof AppSettingsLazyRoute
  '/_app/team': typeof AppTeamLazyRoute
  '/auth/2fa-enable': typeof Auth2faEnableLazyRoute
  '/auth/login': typeof AuthLoginLazyRoute
  '/auth/logout': typeof AuthLogoutLazyRoute
  '/auth/password-reset': typeof AuthPasswordResetLazyRoute
  '/_app/': typeof AppIndexLazyRoute
  '/_app/users/add': typeof AppUsersAddLazyRoute
  '/_app/users/': typeof AppUsersIndexLazyRoute
  '/_app/users/$userId/edit': typeof AppUsersUserIdEditLazyRoute
  '/_app/users/compare/$userId': typeof AppUsersCompareUserIdLazyRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/auth'
    | '/absence'
    | '/clients'
    | '/dashboard'
    | '/profile'
    | '/settings'
    | '/team'
    | '/auth/2fa-enable'
    | '/auth/login'
    | '/auth/logout'
    | '/auth/password-reset'
    | '/'
    | '/users/add'
    | '/users'
    | '/users/$userId/edit'
    | '/users/compare/$userId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/auth'
    | '/absence'
    | '/clients'
    | '/dashboard'
    | '/profile'
    | '/settings'
    | '/team'
    | '/auth/2fa-enable'
    | '/auth/login'
    | '/auth/logout'
    | '/auth/password-reset'
    | '/'
    | '/users/add'
    | '/users'
    | '/users/$userId/edit'
    | '/users/compare/$userId'
  id:
    | '__root__'
    | '/_app'
    | '/auth'
    | '/_app/absence'
    | '/_app/clients'
    | '/_app/dashboard'
    | '/_app/profile'
    | '/_app/settings'
    | '/_app/team'
    | '/auth/2fa-enable'
    | '/auth/login'
    | '/auth/logout'
    | '/auth/password-reset'
    | '/_app/'
    | '/_app/users/add'
    | '/_app/users/'
    | '/_app/users/$userId/edit'
    | '/_app/users/compare/$userId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexLazyRouteImport
      parentRoute: typeof AppRoute
    }
    '/auth/password-reset': {
      id: '/auth/password-reset'
      path: '/password-reset'
      fullPath: '/auth/password-reset'
      preLoaderRoute: typeof AuthPasswordResetLazyRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/logout': {
      id: '/auth/logout'
      path: '/logout'
      fullPath: '/auth/logout'
      preLoaderRoute: typeof AuthLogoutLazyRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/login': {
      id: '/auth/login'
      path: '/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLoginLazyRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/2fa-enable': {
      id: '/auth/2fa-enable'
      path: '/2fa-enable'
      fullPath: '/auth/2fa-enable'
      preLoaderRoute: typeof Auth2faEnableLazyRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_app/team': {
      id: '/_app/team'
      path: '/team'
      fullPath: '/team'
      preLoaderRoute: typeof AppTeamLazyRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsLazyRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/profile': {
      id: '/_app/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AppProfileLazyRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dashboard': {
      id: '/_app/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AppDashboardLazyRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/clients': {
      id: '/_app/clients'
      path: '/clients'
      fullPath: '/clients'
      preLoaderRoute: typeof AppClientsLazyRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/absence': {
      id: '/_app/absence'
      path: '/absence'
      fullPath: '/absence'
      preLoaderRoute: typeof AppAbsenceRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/users/': {
      id: '/_app/users/'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AppUsersIndexLazyRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/users/add': {
      id: '/_app/users/add'
      path: '/users/add'
      fullPath: '/users/add'
      preLoaderRoute: typeof AppUsersAddLazyRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/users/compare/$userId': {
      id: '/_app/users/compare/$userId'
      path: '/users/compare/$userId'
      fullPath: '/users/compare/$userId'
      preLoaderRoute: typeof AppUsersCompareUserIdLazyRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/users/$userId/edit': {
      id: '/_app/users/$userId/edit'
      path: '/users/$userId/edit'
      fullPath: '/users/$userId/edit'
      preLoaderRoute: typeof AppUsersUserIdEditLazyRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppAbsenceRoute: typeof AppAbsenceRoute
  AppClientsLazyRoute: typeof AppClientsLazyRoute
  AppDashboardLazyRoute: typeof AppDashboardLazyRoute
  AppProfileLazyRoute: typeof AppProfileLazyRoute
  AppSettingsLazyRoute: typeof AppSettingsLazyRoute
  AppTeamLazyRoute: typeof AppTeamLazyRoute
  AppIndexLazyRoute: typeof AppIndexLazyRoute
  AppUsersAddLazyRoute: typeof AppUsersAddLazyRoute
  AppUsersIndexLazyRoute: typeof AppUsersIndexLazyRoute
  AppUsersUserIdEditLazyRoute: typeof AppUsersUserIdEditLazyRoute
  AppUsersCompareUserIdLazyRoute: typeof AppUsersCompareUserIdLazyRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAbsenceRoute: AppAbsenceRoute,
  AppClientsLazyRoute: AppClientsLazyRoute,
  AppDashboardLazyRoute: AppDashboardLazyRoute,
  AppProfileLazyRoute: AppProfileLazyRoute,
  AppSettingsLazyRoute: AppSettingsLazyRoute,
  AppTeamLazyRoute: AppTeamLazyRoute,
  AppIndexLazyRoute: AppIndexLazyRoute,
  AppUsersAddLazyRoute: AppUsersAddLazyRoute,
  AppUsersIndexLazyRoute: AppUsersIndexLazyRoute,
  AppUsersUserIdEditLazyRoute: AppUsersUserIdEditLazyRoute,
  AppUsersCompareUserIdLazyRoute: AppUsersCompareUserIdLazyRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface AuthRouteChildren {
  Auth2faEnableLazyRoute: typeof Auth2faEnableLazyRoute
  AuthLoginLazyRoute: typeof AuthLoginLazyRoute
  AuthLogoutLazyRoute: typeof AuthLogoutLazyRoute
  AuthPasswordResetLazyRoute: typeof AuthPasswordResetLazyRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  Auth2faEnableLazyRoute: Auth2faEnableLazyRoute,
  AuthLoginLazyRoute: AuthLoginLazyRoute,
  AuthLogoutLazyRoute: AuthLogoutLazyRoute,
  AuthPasswordResetLazyRoute: AuthPasswordResetLazyRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
